import Swiper from 'swiper';
import { MOBILE } from '../../assets/scripts/constants';

class Location {
	constructor(el) {
		this.el = el;
		this.mm = window.matchMedia(MOBILE);
		this.swiper = null;

		this.toggleSwiper(this.mm.matches);

		this.mm.addEventListener('change', (e) => {
			this.toggleSwiper(e.matches);
		});
	}

	initSwiper() {
		if (!this.swiper) {
			this.swiper = new Swiper(this.el.querySelector('.swiper'), {
				slidesPerView: 'auto',
				spaceBetween: 2,
				loop: true,
			});
		}
	}

	destroySwiper() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
	}

	toggleSwiper(isMobile) {
		if (isMobile) {
			this.initSwiper();
		} else {
			this.destroySwiper();
		}
	}
}

document.querySelectorAll('[data-location]').forEach((el) => new Location(el));
export default Location;
